import Hero from "../designSystem/Hero";
import PrimaryButtonSmall from "../designSystem/buttons/PrimaryButtonSmall";
import SEO from "../designSystem/SEO";
import AboutChris from "../../assets/images/mortgage_protection_advice_01.png";
import AboutMichael from "../../assets/images/mortgage_protection_advice_02.png";
import TeamAdvice from "../../assets/images/mortgage_protection_advice_03.png";
import AboutBanner from "../../assets/images/homepage_01.png";

const values = [
  {
    title: "Personal",
    description: "Every recommendation starts with understanding you.",
  },
  {
    title: "Honest",
    description: "Clear advice without jargon or unnecessary complexity.",
  },
  {
    title: "Professional",
    description:
      "Experienced advisers committed to achieving the right outcome.",
  },
  {
    title: "Responsive",
    description:
      "Keeping you informed and making the mortgage process as smooth as possible.",
  },
];

const ValueIcon = () => (
  <span
    className="row-center bg-gray-3 p-s all-radius-m text-primary-2"
    aria-hidden="true"
  >
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M4 11.5 12 5l8 6.5M6.5 10.5V20h11v-9.5M10 20v-5.5h4V20" />
    </svg>
  </span>
);

const AboutUsPage = () => {
  return (
    <div>
      <SEO
        title="About CAPC Mortgages"
        description="Learn about CAPC Mortgages, our experienced advisers and our personal, straightforward approach to mortgage and protection advice."
        path="/about-us"
      />
      <Hero backgroundImage={AboutBanner} wantOverlay={false}>
        <div className="content-container">
          <div className="column gap-m align-center">
            <div className="nav-text text-secondary-1 uppercase">ABOUT US</div>
            <h1 className="text-primary-1 text-center">
              Mortgage and Protection Advice
            </h1>
            <div className="content text-primary-2 text-center">
              At Christopher Allen Private Clients, we provide bespoke mortgage
              and protection advice tailored to your individual needs. Whether
              you're buying your first home, remortgaging, investing in property
              or arranging specialist finance, our experienced advisers are here
              to make the process straightforward and stress-free.
            </div>
          </div>
        </div>
      </Hero>
      {/* <section className="background-container bg-gray-3">
        <div className="content-container ">
          <div className="column-center gap-l">
            <div className="content text-gray-1 text-center">
              You are now departing from the regulatory site of Christopher
              Allen Private Clients Limited. Neither Christopher Allen Private
              Clients Limited Nor RWith access to over 90 UK lenders, including
              high street banks, specialist lenders and private banks, we search
              the market to find mortgage solutions that suit your circumstances
              and long-term goals.
            </div>
            <div className="content text-gray-1 text-center">
              We pride ourselves on building lasting relationships with our
              clients, offering honest advice, personal service and ongoing
              support long after your mortgage has completed. Our aim is simple:
              to provide expert guidance and help you secure the right mortgage
              with confidence.osemount Financial Solutions (IFA) Ltd are
              responsible for the accuracy of the information contained within
              the linked site.
            </div>
          </div>
        </div>
      </section> */}

      <section className="background-container bg-primary-2">
        <div className="content-container grid2 gap-xxxxl grid-stretch">
          <article className="column gap-l">
            <div className="nav-text text-secondary-1 uppercase">Director</div>
            <h4 className="text-white">Chris Hewitt</h4>
            <div className="content text-white">
              Chris started his career in financial services in 1995 providing
              advice to clients and companies in the pension, investment and
              protection arena for the Prudential before moving to John Charcol
              as a Senior Consultant / Mortgage Broker, predominantly dealing
              with High Net Worth Individuals and assisting with complex prime
              and larger Buy to Let Portfolios.​After a spell as a founding
              broker with Capital Private Finance, starting in 2010, which
              became one of the premier brokerages in London, Chris established
              his own brokerage CAPC and set up TAG Mortgages in 2018 to provide
              a branded solution for the network and our clients.
            </div>
          </article>
          <img
            src={AboutChris}
            alt="Chris Hewitt, director at CAPC Mortgages"
            className="hero-image height-auto"
          />
        </div>
      </section>

      <section className="background-container bg-white">
        <div className="content-container grid2 gap-xxxxl grid-stretch">
          <img
            src={AboutMichael}
            alt="Michael Batchelor, director and mortgage adviser at CAPC Mortgages"
            className="hero-image height-auto"
          />
          <article className="column gap-l">
            <div className="nav-text text-secondary-1 uppercase">Director</div>
            <h4 className="text-primary-2">Michael Batchelor</h4>
            <div className="column gap-m">
              <div className="content text-primary-2">
                Michael is a director and mortgage adviser at CAPC Mortgages
                providing Residential & Buy to Let mortgage solutions to a
                diverse range of clients including First Time Buyers, High Net
                Worths and Portfolio Landlords. Having originally started his
                career in tax and accountancy he progressed into mortgage advice
                where he works predominantly with property agents, accountants
                and financial advisers to provide bespoke solutions for their
                clients. Alongside CAPC, Michael is also a director and adviser
                at TAG Commercial Mortgages providing commercial lending options
                including bridging, development, and commercial term mortgages.
              </div>
              <div className="content text-primary-2">
                Michael has been in the industry for over 10 years and has
                achieved High Achievers Status on multiple occasions.  
              </div>
              <div className="content text-primary-2">
                Outside of mortgage advice, Michael is a portfolio landlord with
                properties in both personal name and limited company and he is
                chairman of a local adult’s football club.
              </div>
            </div>
          </article>
        </div>
      </section>

      <section className="background-container bg-gray-3">
        <div className="content-container">
          <div className="column gap-l align-center">
            <div className="body2-semibold text-secondary-1 uppercase">
              About Us
            </div>
            <h4 className="text-primary-2 text-center">The CAPC Team</h4>
            <img
              src={TeamAdvice}
              alt="The CAPC mortgage and protection advice team"
              className="hero-image height-auto"
            />
            <div className="content text-primary-2 text-center">
              The team at CAPC combines extensive industry knowledge with a
              genuinely personal approach to mortgage and protection advice.
              Every member of our team is committed to understanding your
              individual circumstances, providing clear guidance and delivering
              tailored solutions that support your financial goals. From your
              first enquiry through to completion and beyond, we work closely
              together to make the process as straightforward and stress-free as
              possible. By building long-term relationships based on trust,
              professionalism and exceptional service, we're here to provide
              expert support whenever you need us, helping you move forward with
              confidence at every stage of your property journey.
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutUsPage;
